import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useDesktopSessionStore } from '@/desktop/desktopSessionStore';
import { isDesktopApp } from '@/desktop/electronApi';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

/** Soft banner when cloud session expired but local unlock is still active. */
export default function CloudSessionBanner() {
  const expired = useDesktopSessionStore((s) => s.cloudSessionExpired);
  const locallyUnlocked = useDesktopSessionStore((s) => s.locallyUnlocked);
  const navigate = useNavigate();
  const clearAuth = useAuthStore((s) => s.clearAuth);
  const clearLocalUnlock = useDesktopSessionStore((s) => s.clearLocalUnlock);

  // Hide on unlock screen / before PIN — avoid false “session missing” flash on reload.
  if (!isDesktopApp() || !expired || !locallyUnlocked) return null;

  return (
    <div className="bg-amber-50 border-b border-amber-200 text-amber-900 px-3 py-2 text-xs flex flex-wrap items-center gap-2">
      <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
      <span className="flex-1">
        Cloud session expired — use Online login to refresh server access. Offline / Local First can
        still sell from the local catalog.
      </span>
      <button
        type="button"
        onClick={() => {
          // Must clear persisted auth or /login redirects away immediately.
          clearLocalUnlock();
          clearAuth();
          navigate('/login', { replace: true });
        }}
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded border border-amber-300 bg-white hover:bg-amber-50"
      >
        <RefreshCw className="w-3 h-3" /> Online login
      </button>
    </div>
  );
}
